/*
 * Yonex CPH: EEN kilde til koeb fra produktsiden.
 *
 * Pakkebyggeren (sections/yonex-bundle-builder.liquid), mobilens komplet-saet
 * (snippets/yonex-complete-set.liquid) og opstrengnings-valget
 * (snippets/yonex-stringing-options.liquid) laeser alle den AKTIVE variant og
 * det valgte antal her, og sender ordrelinjerne gennem det samme kald.
 *
 * Rettet 2026-09-05 efter Codex-fund A1, A2, A3 og A4 samt QA-fund K1.
 * Foer laeste hver knap sin egen variant. Pakkebyggeren brugte
 * product.variants.first, saa kundens valg blev ignoreret.
 */
(function () {
  'use strict';

  if (window.YonexCart) return;

  // Hovedproduktets formular. Prestige giver den id'et
  // "product-form-main-<produkt>-<sektion>__main". Sticky-baren hedder
  // "product-form-quick-buy-...__main" og maa ikke rammes.
  var MAIN_FORM_SELECTOR = 'form.shopify-product-form[id^="product-form-main-"][id$="__main"]';

  function mainForm() {
    return document.querySelector(MAIN_FORM_SELECTOR);
  }

  // form.elements finder ogsaa felter uden for formularen, der peger paa den
  // med form="...". Antals-feltet ligger uden for.
  function field(form, navn) {
    if (!form || !form.elements) return null;
    var el = form.elements.namedItem(navn);
    if (!el) return null;
    if (el.length && !('value' in el)) return el[0] || null;
    return el;
  }

  // Prestige udskriver den valgte variant som JSON i variant-vaelgeren og
  // gentegner den ved variantskift. Det er den mest paalidelige kilde til
  // pris og tilgaengelighed.
  function variantData() {
    var form = mainForm();
    // VIGTIGT: form.id giver IKKE id-strengen her. Formularen har et felt med
    // name="id", og navngivne felter skygger for elementets egne egenskaber.
    // Attributten skal laeses direkte.
    var formId = form && form.getAttribute('id');
    if (!formId) return null;
    var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');
    var node = picker && picker.querySelector('script[data-variant]');
    if (!node) return null;
    try {
      var v = JSON.parse(node.textContent);
      return v && v.id ? v : null;
    } catch (e) {
      return null;
    }
  }

  function activeVariantId() {
    var v = variantData();
    if (v) return v.id;
    var el = field(mainForm(), 'id');
    var n = el ? parseInt(el.value, 10) : NaN;
    return isFinite(n) && n > 0 ? n : null;
  }

  function activeVariantPrice() {
    var v = variantData();
    return v && typeof v.price === 'number' ? v.price : null;
  }

  // Ukendt tilstand behandles som "kan koebes", saa vi aldrig blokerer et
  // gyldigt koeb, fordi markup'en er anderledes end forventet.
  function activeVariantAvailable() {
    var v = variantData();
    if (v && typeof v.available === 'boolean') return v.available;
    return true;
  }

  function activeQuantity() {
    var el = field(mainForm(), 'quantity');
    var n = el ? parseInt(el.value, 10) : NaN;
    return isFinite(n) && n > 0 ? n : 1;
  }

  // Prestige sender "variant:change" fra formularen, og den bobler til
  // document. Vi giver abonnenten den friske variant med.
  function onVariantChange(cb) {
    document.addEventListener('variant:change', function () {
      cb({
        id: activeVariantId(),
        price: activeVariantPrice(),
        available: activeVariantAvailable(),
        quantity: activeQuantity(),
      });
    });
    var form = mainForm();
    var qty = field(form, 'quantity');
    if (qty) {
      qty.addEventListener('change', function () {
        cb({
          id: activeVariantId(),
          price: activeVariantPrice(),
          available: activeVariantAvailable(),
          quantity: activeQuantity(),
        });
      });
    }
  }

  function newBundleId() {
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  // Laeser Shopifys egen fejlbeskrivelse, saa kunden ser hvad der gik galt.
  function fejlTekst(body, fallback) {
    if (body && typeof body === 'object') {
      if (body.description) return String(body.description);
      if (body.message) return String(body.message);
    }
    return fallback;
  }

  // Ét kald til /cart/add.js. Kaster en Error med .beskrivelse ved fejl.
  async function addItems(items, fallbackFejl) {
    var res;
    var body = null;
    try {
      res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });
    } catch (netfejl) {
      var e1 = new Error('netvaerksfejl');
      e1.beskrivelse = fallbackFejl;
      throw e1;
    }
    try {
      body = await res.json();
    } catch (e) {
      body = null;
    }
    if (!res.ok) {
      var e2 = new Error('cart-add ' + res.status);
      e2.status = res.status;
      e2.beskrivelse = fejlTekst(body, fallbackFejl);
      throw e2;
    }
    return body;
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('on:cart:loaded'));
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer, [is="cart-drawer"]');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
      return true;
    }
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    var btn = document.querySelector('[aria-controls="cart-drawer"], .header__cart-link');
    if (btn) {
      btn.click();
      return true;
    }
    return false;
  }

  window.YonexCart = {
    mainForm: mainForm,
    activeVariantId: activeVariantId,
    activeVariantPrice: activeVariantPrice,
    activeVariantAvailable: activeVariantAvailable,
    activeQuantity: activeQuantity,
    onVariantChange: onVariantChange,
    newBundleId: newBundleId,
    addItems: addItems,
    refreshCart: refreshCart,
    openDrawer: openDrawer,
  };
})();
